import React from 'react';
import classnames from 'classnames';
import { useTheme } from '../theme';

export type CardContentProps = React.HTMLAttributes<HTMLDivElement>;

export const CardContent = ({ className, ...props }: CardContentProps): React.ReactElement => {
  const theme = useTheme();
  const classNames = classnames(className, 'airtame-card__content');
  return <div className={classNames} data-theme={theme} {...props} />;
};

CardContent.displayName = 'CardContent';
